import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { navLinks } from '@/mocks/siteConfig';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = window.location.pathname === '/' || window.location.pathname === '';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHomePage
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a href="/" className="flex items-center gap-2">
            <span className={`text-xl font-bold tracking-tight transition-colors duration-300 ${
              scrolled || !isHomePage ? 'text-foreground-950' : 'text-background-50'
            }`}>
              hlw
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  scrolled || !isHomePage
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/70'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {t(link.label === '首页' ? 'nav.home' : link.label === '功能介绍' ? 'nav.features' : link.label === '使用指南' ? 'nav.guide' : link.label === '适用场景' ? 'nav.scenarios' : link.label === '用户评价' ? 'nav.reviews' : 'nav.about')}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled || !isHomePage ? 'text-foreground-600 hover:text-foreground-950' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {t('nav.login')}
            </a>
            <a
              href="#"
              className="px-5 py-2 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              {t('nav.register')}
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              scrolled || !isHomePage ? 'text-foreground-950' : 'text-background-50'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50/70 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <hr className="my-2 border-background-200" />
            <div className="flex items-center gap-3 px-4 py-2">
              <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 whitespace-nowrap">
                {t('nav.login')}
              </a>
              <a
                href="#"
                className="px-5 py-2 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                {t('nav.register')}
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}